export default __webpack_public_path__ + "static/media/LAGARTIJEANDO.1e8bdfe9.gif";